export const DocsFilled = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={ 14 }
			height={ 14 }
			fill="none"
		>
			<path
				stroke="#757575"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.75 1.458v.875c0 .825 0 1.238.256 1.494.257.256.67.256 1.494.256h.875"
			/>
			<path
				stroke="#757575"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M2.333 9.333V4.667c0-1.65 0-2.475.513-2.988.512-.512 1.337-.512 2.987-.512h2.434c.238 0 .357 0 .465.044.107.045.191.129.36.297l2.233 2.234c.168.168.253.253.297.36.045.107.045.226.045.465v4.766c0 1.65 0 2.475-.513 2.988-.513.512-1.338.512-2.987.512H5.833c-1.65 0-2.475 0-2.987-.512-.513-.513-.513-1.338-.513-2.988ZM4.667 6.417h4.666m-4.666 1.75h4.666m-4.666 1.75H7.1"
			/>
		</svg>
	);
};
export const Demos = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={ 14 }
			height={ 14 }
			fill="none"
		>
			<path
				stroke="#757575"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M6.474 1.75c-2.128.004-3.243.056-3.955.769-.769.768-.769 2.006-.769 4.48 0 2.476 0 3.713.769 4.482.769.769 2.006.769 4.48.769 2.475 0 3.712 0 4.481-.769.712-.712.764-1.827.768-3.956M11.99 2.04 6.446 7.617m5.546-5.579c-.288-.288-2.23-.261-2.64-.255m2.64.255c.288.289.261 2.233.255 2.644"
			/>
		</svg>
	);
};

export const CloseIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		fill="none"
		viewBox="0 0 16 16"
	>
		<path
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="m14.5 1.5-13 13m0-13 13 13"
		></path>
	</svg>
);
export const LWLogo = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="229"
		height="32"
		fill="none"
		viewBox="0 0 229 32"
	>
		<path
			fill="#fff"
			d="M27.458 11.463c.158-5.437-7.713-7.879-10.986-3.487 1.266.896 2.256 1.915 2.913 3.259 2.894-.255 5.678 1.37 6.76 3.856.842-1.045 1.332-2.319 1.313-3.628M21.392 4.05c1.433.035.749-2.451.897-3.198 0-.456-.417-.852-.898-.852-1.433-.035-.749 2.451-.896 3.198-.01.456.406.852.896.852m6.797 2.17 1.73-1.643c.822-.756-.454-1.968-1.25-1.186L26.94 5.034c-.823.764.453 1.976 1.249 1.185m4.402 4.418h-2.46c-1.165 0-1.165 1.713 0 1.713h2.46c1.165 0 1.137-1.713 0-1.713m-4.402 6.122c-.796-.782-2.072.43-1.249 1.186l1.73 1.642c.795.782 2.071-.43 1.248-1.185 0 .008-1.73-1.643-1.73-1.643M14.557 6.22c.795.781 2.072-.431 1.249-1.186l-1.73-1.643c-.74-.843-2.09.44-1.248 1.186zm8.915 8.072c-4.55-3.76-6.316.913-8.462.298-1.11-1.344 1.61-2.477 2.636-2.933-3.385-5.789-11.976-3.365-13.003 2.67-2.404.158-4.689 1.546-4.642 4.084-.019 2.179 1.868 3.97 4.161 3.953H19.94c4.318.08 6.668-5.305 3.532-8.072M4.052 20.15c-2.488.035-2.488-3.672 0-3.637 2.487-.035 2.487 3.672 0 3.637m14.806 3.662H1.96c-1.498-.017-1.516 2.24 0 2.223h16.887c2.46-.158 3.339 3.742.574 3.865-.962 0-1.748-.747-1.748-1.67.018-1.431-2.35-1.431-2.33 0-.075 5.025 8.24 5.025 8.156 0 .01-2.432-2.08-4.418-4.642-4.418M54.905 21.73c0 .344.041.634.124.84.076.201.205.378.374.51.166.124.373.207.608.248q.433.072.87.07c.49.005.977-.05 1.452-.166q.576-.15 1.133-.358c.332-.124.595-.262.816-.372s.4-.166.511-.166c.152 0 .277.055.36.152.096.12.146.273.138.427 0 .317-.028.551-.097.69-.069.137-.193.247-.4.316-.807.28-1.641.474-2.489.58q-1.562.2-3.137.192c-.871 0-1.576-.041-2.129-.11-.553-.07-.981-.207-1.3-.4a1.43 1.43 0 0 1-.649-.8c-.11-.344-.18-.757-.18-1.295V8.332c0-.179-.013-.317-.055-.427a.56.56 0 0 0-.166-.248.8.8 0 0 0-.262-.124c-.097-.028-.208-.028-.332-.028a3.3 3.3 0 0 0-.663.083 5.6 5.6 0 0 0-.83.248q-.457.177-.884.414a4.3 4.3 0 0 0-.788.565c-.227.202-.418.439-.567.703a1.63 1.63 0 0 0-.221.84c0 .262.027.47.097.62.069.152.152.263.235.345.083.083.18.124.276.152s.166.027.207.027c.208 0 .374-.027.498-.096s.249-.138.346-.22c.096-.083.207-.152.304-.221a.54.54 0 0 1 .318-.097c.096 0 .207.028.304.07q.17.075.304.206c.096.097.166.22.235.386.069.165.096.345.096.579 0 .317-.069.606-.193.84a2 2 0 0 1-.484.593 1.75 1.75 0 0 1-.677.345q-.373.105-.76.11c-.387 0-.733-.069-1.05-.207a2.286 2.286 0 0 1-1.3-1.378 3 3 0 0 1-.166-1.006c0-.551.097-1.061.304-1.53.204-.461.485-.885.83-1.254.345-.372.76-.703 1.243-.979a9 9 0 0 1 1.535-.703 10 10 0 0 1 1.727-.413 13 13 0 0 1 1.797-.138c.664 0 1.175.069 1.548.193.374.124.636.276.816.455s.276.358.304.551l.055.483V21.73zm6.261-3.46c0-1.061.153-1.985.457-2.784.304-.8.718-1.461 1.23-1.999a4.8 4.8 0 0 1 1.797-1.199 6 6 0 0 1 2.142-.4c.746 0 1.451.124 2.142.373.692.248 1.272.62 1.797 1.13.526.51.927 1.158 1.23 1.93q.457 1.157.457 2.77 0 1.591-.456 2.812c-.305.813-.72 1.502-1.23 2.053a5.1 5.1 0 0 1-1.797 1.268 5.4 5.4 0 0 1-2.143.428 6 6 0 0 1-2.142-.4 5.2 5.2 0 0 1-1.797-1.213c-.525-.538-.926-1.2-1.23-1.998-.304-.8-.456-1.71-.456-2.77m7.464-.124-.069-1.875a8.4 8.4 0 0 0-.262-1.598c-.125-.469-.318-.841-.553-1.117-.235-.275-.567-.413-.954-.413s-.719.151-.954.44-.428.69-.552 1.159a8 8 0 0 0-.25 1.64l-.055 1.888.056 1.902c.032.558.115 1.112.248 1.654.125.482.318.869.553 1.172a1.15 1.15 0 0 0 .954.44c.387 0 .719-.15.954-.454.235-.303.428-.717.553-1.213a9.5 9.5 0 0 0 .262-1.695zm13.145-2.054c-.249 0-.456-.041-.636-.11a1.05 1.05 0 0 1-.414-.303 1.3 1.3 0 0 1-.235-.427 1.4 1.4 0 0 1-.07-.497q0-.319.042-.634c.028-.206.028-.386.014-.551a.55.55 0 0 0-.194-.386c-.11-.096-.29-.151-.552-.151-.29 0-.58.082-.899.248a2.45 2.45 0 0 0-.857.758c-.249.344-.47.8-.65 1.337s-.248 1.199-.248 1.97c0 .855.083 1.627.235 2.316.152.69.4 1.296.705 1.792.29.473.693.866 1.174 1.144.47.276 1.023.4 1.66.4.29 0 .552-.028.8-.097a4 4 0 0 0 .72-.262q.34-.172.65-.4l.607-.482.305.29c-.18.248-.429.523-.72.827-.29.303-.649.579-1.05.84-.4.262-.898.483-1.451.662a6.5 6.5 0 0 1-1.88.262 5.6 5.6 0 0 1-2.06-.4 5.45 5.45 0 0 1-1.782-1.185 5.6 5.6 0 0 1-1.244-1.889c-.305-.744-.47-1.585-.47-2.522 0-.73.096-1.406.276-2.026s.442-1.171.76-1.681.691-.938 1.12-1.324c.428-.386.87-.703 1.34-.95.47-.249.954-.442 1.438-.58a5.2 5.2 0 0 1 1.41-.192c.594 0 1.12.068 1.562.206s.815.317 1.106.551c.29.235.511.483.663.786s.221.607.221.91c0 .234-.027.455-.096.675a1.9 1.9 0 0 1-.263.552c-.11.151-.263.289-.442.372-.18.082-.36.151-.595.151M88.492 12.895c-.276 0-.525.027-.76.096a2.8 2.8 0 0 0-.608.248 1.6 1.6 0 0 0-.401.317.55.55 0 0 0-.152.331c0 .124.069.207.193.262l.415.18q.233.107.415.288c.124.125.193.317.193.58 0 .165-.028.33-.097.468a1.5 1.5 0 0 1-.276.372 1.04 1.04 0 0 1-.415.248 1.5 1.5 0 0 1-.497.097c-.456 0-.816-.152-1.106-.455s-.415-.717-.415-1.227c0-.496.125-.91.387-1.268a3.1 3.1 0 0 1 1.01-.868q.621-.352 1.41-.496a8.8 8.8 0 0 1 1.575-.166c.636 0 1.23.07 1.81.207a4.7 4.7 0 0 1 1.521.648c.442.29.788.675 1.05 1.144.263.468.401 1.02.401 1.668v6.85c0 .069 0 .151.014.248a1.3 1.3 0 0 0 .055.248.33.33 0 0 0 .152.18.578.578 0 0 0 .677-.097q.188-.165.332-.331l.305.248-.443.551a3.598 3.598 0 0 1-1.479 1.02c-.331.124-.69.18-1.105.18-.512 0-.968-.152-1.355-.455-.4-.304-.65-.772-.774-1.406a5.5 5.5 0 0 1-.802.868q-.392.337-.857.565c-.29.138-.58.248-.884.317a4 4 0 0 1-.899.097c-.387 0-.76-.055-1.133-.18a2.7 2.7 0 0 1-.982-.578 2.7 2.7 0 0 1-.69-1.02c-.167-.414-.263-.938-.263-1.544 0-.73.152-1.337.442-1.806a3.9 3.9 0 0 1 1.147-1.185 7.4 7.4 0 0 1 1.617-.813l1.853-.717c.47-.18.815-.469 1.022-.827.204-.342.314-.732.318-1.13 0-.593-.18-1.075-.525-1.434-.346-.358-.788-.523-1.396-.523m1.935 5.306c0-.207-.069-.358-.193-.455a.8.8 0 0 0-.498-.151c-.29 0-.553.069-.802.193a2 2 0 0 0-.677.565 2.9 2.9 0 0 0-.456.923 4.4 4.4 0 0 0-.166 1.282c0 .469.028.855.097 1.158s.166.551.276.73c.11.18.25.304.401.386.15.077.316.115.484.11.21.001.415-.056.594-.165q.276-.167.484-.413a2.1 2.1 0 0 0 .332-.565 1.7 1.7 0 0 0 .124-.634zm10.242-5.265v8.959c0 .427.083.73.249.896q.249.248.664.248a.94.94 0 0 0 .58-.18c.166-.123.318-.261.442-.413a2.2 2.2 0 0 0 .374-.592l.373.165-.429.855a3.2 3.2 0 0 1-.663.854 3.5 3.5 0 0 1-1.037.662c-.414.179-.94.262-1.575.262-.36 0-.705-.055-1.023-.152a2.4 2.4 0 0 1-.871-.496 2.5 2.5 0 0 1-.608-.855c-.152-.344-.235-.744-.235-1.226V12.95h-1.355v-.869c.221 0 .54-.055.954-.179a4.9 4.9 0 0 0 1.244-.592c.428-.276.815-.648 1.189-1.103.373-.455.622-1.034.774-1.71h.967v3.57h1.977c.649 0 .967-.11.967-.33q0-.124-.124-.166c-.083-.027-.166-.069-.277-.11a.8.8 0 0 1-.276-.193c-.083-.083-.124-.22-.124-.4q0-.33.207-.537c.138-.138.332-.193.553-.193.152 0 .276.028.387.097a.8.8 0 0 1 .276.248q.104.162.166.344c.042.124.055.262.055.386 0 .524-.152.937-.456 1.254s-.788.469-1.465.469z"
		></path>
		<path
			fill="#fff"
			d="M108.604 23.384c0 .11-.014.234-.055.386-.042.151-.124.289-.249.427-.138.138-.332.248-.58.344-.249.097-.595.138-1.023.138-.429 0-.76-.055-1.009-.151a1.4 1.4 0 0 1-.553-.359.85.85 0 0 1-.221-.427 2 2 0 0 1-.042-.345V14.04c0-.235-.055-.441-.166-.607-.11-.165-.29-.262-.553-.262a.9.9 0 0 0-.345.07c-.097.04-.207.11-.318.206l-.249-.303c.18-.152.401-.304.622-.455s.484-.276.747-.4q.413-.184.857-.276a4.4 4.4 0 0 1 .967-.11c.525 0 .94.07 1.23.207.291.138.512.317.65.524a1.5 1.5 0 0 1 .249.661q.04.352.041.62zm-4.105-14.252a1.53 1.53 0 0 1 .581-1.186c.186-.159.402-.28.635-.358.249-.083.498-.138.788-.138.277 0 .539.042.774.138.235.097.443.207.622.358q.27.228.415.538a1.456 1.456 0 0 1 0 1.296c-.101.2-.242.379-.415.523a2.3 2.3 0 0 1-.622.359 2 2 0 0 1-.774.138 2.1 2.1 0 0 1-.788-.138 2.2 2.2 0 0 1-.635-.359 1.9 1.9 0 0 1-.429-.523 1.3 1.3 0 0 1-.152-.648m5.764 9.138c0-1.061.152-1.985.456-2.784.304-.8.719-1.461 1.23-1.999a4.8 4.8 0 0 1 1.797-1.199 6 6 0 0 1 2.142-.4c.747 0 1.452.124 2.143.373.691.248 1.272.62 1.797 1.13s.926 1.158 1.23 1.93q.456 1.157.456 2.77 0 1.591-.456 2.812c-.304.813-.719 1.502-1.23 2.053a5.14 5.14 0 0 1-1.797 1.268 5.4 5.4 0 0 1-2.143.428 6 6 0 0 1-2.142-.4 5.25 5.25 0 0 1-1.797-1.213c-.525-.538-.926-1.2-1.23-1.998-.304-.8-.456-1.71-.456-2.77m7.478-.124-.069-1.875a7.5 7.5 0 0 0-.263-1.598c-.138-.469-.318-.841-.553-1.117-.235-.275-.567-.413-.954-.413s-.718.151-.953.44-.429.69-.553 1.159a8 8 0 0 0-.249 1.64l-.055 1.888.055 1.902c.032.558.115 1.112.249 1.654.124.482.318.869.553 1.172a1.14 1.14 0 0 0 .953.44c.387 0 .719-.15.954-.454.235-.303.428-.717.553-1.213a9.6 9.6 0 0 0 .263-1.695zm12.564.29c0-1.02-.042-1.834-.138-2.44-.097-.607-.221-1.075-.373-1.392-.153-.317-.318-.524-.512-.634a1.1 1.1 0 0 0-.567-.152c-.235 0-.442.069-.622.193a2 2 0 0 0-.47.427q-.193.227-.345.483c-.097.165-.166.29-.235.358v8.09c0 .111-.014.235-.055.387a.9.9 0 0 1-.235.427c-.125.138-.318.248-.553.345s-.581.138-1.009.138c-.429 0-.774-.056-1.009-.152-.249-.097-.443-.22-.567-.358a1.06 1.06 0 0 1-.249-.428 1.3 1.3 0 0 1-.055-.344v-9.36c0-.233-.055-.44-.166-.606-.111-.179-.29-.261-.553-.261a.9.9 0 0 0-.345.068c-.097.042-.208.11-.318.207l-.249-.303c.18-.152.401-.303.622-.455q.36-.225.746-.4.413-.184.857-.275a4.4 4.4 0 0 1 .968-.11c.525 0 .94.082 1.23.261.29.18.511.386.65.62.138.235.221.497.248.759l.042.661a6.3 6.3 0 0 1 1.023-1.144 5 5 0 0 1 .511-.427q.287-.215.608-.372.327-.162.678-.262c.235-.069.483-.096.732-.096.553 0 1.037.11 1.465.317.429.206.788.565 1.078 1.047s.512 1.144.664 1.957.235 1.82.235 3.019c0 1.171-.111 2.191-.318 3.046-.207.854-.484 1.599-.829 2.205-.346.607-.719 1.103-1.148 1.489a5.9 5.9 0 0 1-1.299.91c-.442.22-.857.371-1.258.454s-.746.138-1.036.138l-.139-.496q.357-.085.678-.262c.224-.138.417-.321.566-.538.166-.234.318-.537.457-.896.124-.358.235-.813.331-1.35q.16-.952.208-1.916zm22.336 1.791.553-1.543.567-1.71.539-1.778.47-1.778-1.175-3.845a1.02 1.02 0 0 1 .014-.703c.083-.207.235-.358.442-.496s.443-.235.719-.303a3.7 3.7 0 0 1 .885-.097c.262 0 .511.014.718.041.208.028.401.083.553.152s.291.18.401.303c.111.124.194.303.249.51l3.483 11.192.581-1.626.594-1.792.553-1.86.47-1.848.318-1.736c.069-.552.11-1.062.11-1.517a7 7 0 0 0-.11-1.337 5 5 0 0 0-.249-.895l-.249-.593a1 1 0 0 1-.11-.427c0-.166.041-.317.138-.428s.207-.22.345-.303a1.87 1.87 0 0 1 .913-.234c.318 0 .594.055.829.151a.8.8 0 0 1 .47.497 3 3 0 0 1 .097.385q.036.192.055.386c.014.124.014.249.014.345v.262c0 .344-.056.8-.166 1.392l-.456 1.999-.65 2.384-.76 2.564-.802 2.522-.76 2.288-.636 1.847-.414 1.185c-.053.17-.143.325-.263.455-.111.11-.235.193-.373.262q-.22.09-.456.11l-.512.028c-.318 0-.594-.028-.802-.097a1.7 1.7 0 0 1-.497-.248.9.9 0 0 1-.263-.317l-.138-.303-2.419-7.925-.815 2.591-.788 2.357-.664 1.888-.456 1.186a1.4 1.4 0 0 1-.29.454 1.8 1.8 0 0 1-.387.262 1.6 1.6 0 0 1-.456.11l-.498.028c-.318 0-.594-.027-.801-.096a1.7 1.7 0 0 1-.498-.248 1.2 1.2 0 0 1-.277-.318l-.138-.303-4.326-14.417a4.5 4.5 0 0 0-.263-.703 1.5 1.5 0 0 0-.345-.468 1.2 1.2 0 0 0-.484-.262 2.6 2.6 0 0 0-.705-.083q-.332 0-.788.165c-.308.118-.597.28-.857.483-.276.206-.497.482-.691.8-.193.316-.276.688-.276 1.102 0 .262.027.469.11.62.069.152.152.262.235.345s.18.124.277.151l.193.028c.208 0 .373-.028.498-.097.124-.069.249-.138.345-.22.097-.083.208-.152.291-.22a.5.5 0 0 1 .318-.097c.096 0 .207.027.304.069a.9.9 0 0 1 .304.207c.096.096.166.22.235.385.069.166.096.345.096.58 0 .316-.069.606-.193.84a2 2 0 0 1-.484.593 2 2 0 0 1-.677.344 2.5 2.5 0 0 1-.76.11q-.58 0-1.037-.206a2.2 2.2 0 0 1-.76-.552 2.5 2.5 0 0 1-.47-.813 3 3 0 0 1-.166-1.006c0-.84.166-1.571.484-2.205a4.6 4.6 0 0 1 1.285-1.571 5.5 5.5 0 0 1 1.825-.938 7.2 7.2 0 0 1 2.101-.303q1.223 0 1.99.372c.511.248.94.565 1.258.951s.58.827.76 1.296l.498 1.42zM169.379 18.918c0 .262.042.537.111.84.069.304.193.607.332.91.138.304.331.593.539.883.207.289.456.523.746.744.277.22.594.386.926.523.332.138.719.194 1.12.194.29 0 .553-.028.788-.097s.47-.152.677-.262a4 4 0 0 0 .608-.4l.581-.482.304.29a9 9 0 0 1-.719.826c-.29.304-.65.58-1.051.841-.4.262-.898.483-1.451.662a6.5 6.5 0 0 1-1.88.262 5.6 5.6 0 0 1-2.059-.386 5.3 5.3 0 0 1-1.783-1.144q-.788-.765-1.244-1.902c-.318-.758-.47-1.654-.47-2.66 0-.731.097-1.406.276-2.027a6.306 6.306 0 0 1 1.88-2.95c.41-.358.86-.668 1.341-.923.456-.24.938-.424 1.437-.551a5.82 5.82 0 0 1 2.972 0 3.3 3.3 0 0 1 1.106.524c.275.2.501.46.663.758.146.276.222.584.221.896 0 .386-.11.716-.331 1.02a3.3 3.3 0 0 1-.871.8zm2.447-2.467q.142-.083.262-.193a.65.65 0 0 0 .166-.22 1.4 1.4 0 0 0 .097-.318c.028-.124.028-.276.028-.468 0-.207-.028-.428-.069-.676a3 3 0 0 0-.222-.703 1.6 1.6 0 0 0-.4-.551.83.83 0 0 0-.581-.22c-.29 0-.539.082-.746.261-.208.18-.373.4-.512.676a4.4 4.4 0 0 0-.318.937q-.122.525-.179 1.061l-.069 1.02-.014.827zM180.687 12.895c-.276 0-.525.027-.76.096a2.8 2.8 0 0 0-.608.248 1.6 1.6 0 0 0-.401.317.55.55 0 0 0-.152.331c0 .124.055.207.193.262l.415.18c.154.07.295.168.415.288.124.125.193.317.193.58 0 .165-.041.33-.097.468a1.5 1.5 0 0 1-.276.372q-.166.165-.415.248a1.5 1.5 0 0 1-.497.097c-.457 0-.816-.152-1.092-.455s-.415-.717-.415-1.227c0-.496.124-.91.387-1.268a3.1 3.1 0 0 1 1.009-.868 4.5 4.5 0 0 1 1.41-.496 8.7 8.7 0 0 1 1.576-.166c.635 0 1.23.07 1.81.207a4.7 4.7 0 0 1 1.521.648c.435.293.795.686 1.05 1.144.263.468.401 1.02.401 1.668v6.85a1.7 1.7 0 0 0 .069.496.33.33 0 0 0 .152.18.575.575 0 0 0 .677-.097q.187-.165.332-.331l.304.248-.442.551a3.603 3.603 0 0 1-1.479 1.02c-.332.124-.691.18-1.106.18a2.14 2.14 0 0 1-1.354-.455c-.401-.304-.65-.772-.774-1.406a5.5 5.5 0 0 1-.802.868 4 4 0 0 1-.857.565c-.29.138-.581.248-.885.317a4 4 0 0 1-.898.097c-.387 0-.76-.055-1.133-.18a2.7 2.7 0 0 1-.982-.578 2.7 2.7 0 0 1-.691-1.02c-.166-.414-.263-.938-.263-1.544 0-.73.152-1.337.443-1.806.29-.468.677-.868 1.147-1.185a7.4 7.4 0 0 1 1.617-.813l1.852-.717c.47-.18.816-.469 1.023-.827.202-.343.312-.732.318-1.13 0-.593-.18-1.075-.525-1.434-.332-.344-.802-.523-1.41-.523m1.921 5.306c0-.207-.069-.358-.193-.455a.8.8 0 0 0-.498-.151c-.29 0-.553.069-.802.193a1.9 1.9 0 0 0-.677.565 2.9 2.9 0 0 0-.456.923 4.5 4.5 0 0 0-.166 1.282c0 .469.028.855.097 1.158s.166.551.276.73c.111.18.249.304.401.386a1 1 0 0 0 .484.11c.21.001.415-.056.594-.165q.276-.167.484-.413c.138-.166.249-.359.332-.565a1.7 1.7 0 0 0 .124-.634zm10.242-5.265v8.96c0 .426.083.73.249.895q.249.248.664.248a.94.94 0 0 0 .58-.18c.166-.123.318-.261.443-.413.152-.165.276-.372.373-.592l.373.165-.429.855c-.171.32-.395.608-.663.854a3.5 3.5 0 0 1-1.037.662c-.414.179-.94.262-1.575.262a3.6 3.6 0 0 1-1.023-.152 2.5 2.5 0 0 1-.871-.496 2.46 2.46 0 0 1-.608-.855c-.152-.344-.235-.744-.235-1.226V12.95h-1.355v-.869c.221 0 .539-.055.954-.179a4.9 4.9 0 0 0 1.244-.592c.428-.276.815-.648 1.189-1.103.373-.455.622-1.034.774-1.71h.967v3.57h1.977c.649 0 .967-.11.967-.33q0-.124-.124-.166c-.083-.027-.166-.069-.276-.11a.9.9 0 0 1-.277-.193c-.083-.083-.124-.22-.124-.4q0-.33.207-.537c.138-.138.332-.193.553-.193.152 0 .276.028.387.097.11.055.193.137.276.248s.125.22.166.344.055.262.055.386c0 .524-.152.937-.456 1.254s-.787.469-1.465.469zm7.575 1.268a6.3 6.3 0 0 1 1.023-1.144 5 5 0 0 1 .511-.427q.287-.215.608-.372.327-.162.678-.262c.235-.07.483-.097.732-.097.539 0 1.023.11 1.452.317.428.207.787.565 1.078 1.048.29.482.511 1.144.663 1.957s.235 1.82.235 3.018c0 1.172-.11 2.192-.318 3.047-.207.854-.484 1.598-.829 2.205-.346.606-.719 1.103-1.147 1.489-.429.385-.857.689-1.3.91-.442.22-.857.371-1.257.454-.401.083-.747.138-1.051.138l-.124-.496c.359-.083.691-.248.967-.497.277-.248.525-.634.719-1.199s.346-1.295.442-2.233c.097-.937.152-2.15.152-3.624 0-1.02-.041-1.834-.138-2.44-.097-.607-.221-1.075-.359-1.392s-.318-.524-.512-.634a1.14 1.14 0 0 0-.58-.152c-.235 0-.443.069-.622.193-.18.124-.332.262-.47.427q-.193.227-.346.483c-.096.165-.166.29-.235.358v8.09c0 .111-.014.235-.055.387a.9.9 0 0 1-.235.427c-.124.138-.318.248-.553.345s-.58.138-1.009.138-.774-.056-1.023-.152c-.248-.097-.442-.22-.566-.358a.9.9 0 0 1-.235-.428l-.056-.344V7.754c0-.235-.055-.442-.166-.607-.11-.18-.29-.262-.552-.262a.9.9 0 0 0-.36.07c-.097.04-.207.11-.318.206l-.248-.29q.27-.227.621-.454.358-.23.747-.4a4.6 4.6 0 0 1 .871-.276 4.4 4.4 0 0 1 .967-.11c.525 0 .94.069 1.23.207s.512.317.65.523.221.428.249.648l.041.607v6.588zM212.451 18.918c0 .262.041.537.11.84.069.304.194.607.332.91s.332.593.539.883c.207.289.456.523.746.744.277.22.595.386.926.523.332.138.719.194 1.12.194.29 0 .553-.028.788-.097s.47-.152.677-.262.415-.248.608-.4l.581-.482.304.29a9 9 0 0 1-.719.826c-.29.304-.649.58-1.05.841-.401.262-.899.483-1.452.662a6.5 6.5 0 0 1-1.879.262 5.6 5.6 0 0 1-2.06-.386 5.3 5.3 0 0 1-1.783-1.144q-.788-.765-1.244-1.902c-.318-.758-.47-1.654-.47-2.66 0-.731.097-1.406.277-2.027a6.306 6.306 0 0 1 1.879-2.95c.41-.358.86-.668 1.341-.923q.686-.36 1.438-.551a5.82 5.82 0 0 1 2.971 0c.399.104.774.282 1.106.524.275.2.502.46.664.758.145.276.221.584.221.896 0 .386-.111.716-.332 1.02a3.2 3.2 0 0 1-.871.8zm2.446-2.467q.143-.083.263-.193a.7.7 0 0 0 .166-.22 1.5 1.5 0 0 0 .096-.318c.028-.124.028-.276.028-.468 0-.207-.028-.428-.069-.676a3 3 0 0 0-.221-.703 1.6 1.6 0 0 0-.401-.551.83.83 0 0 0-.581-.22c-.29 0-.539.082-.746.261-.207.18-.373.4-.511.676a4.4 4.4 0 0 0-.318.937q-.121.525-.18 1.061l-.069 1.02-.014.827zM224.087 14.452c.305-.469.636-.896.982-1.268l.47-.469a5 5 0 0 1 .525-.413q.264-.181.567-.29a1.7 1.7 0 0 1 .58-.11c.415 0 .733.124.968.372.235.249.345.593.345 1.034a5 5 0 0 1-.069.8 6 6 0 0 1-.262.923h-.346a1.15 1.15 0 0 0-.346-.62c-.179-.166-.442-.248-.774-.248-.248 0-.497.041-.746.137a4 4 0 0 0-.705.345 5.6 5.6 0 0 0-.65.455l-.566.455v7.856q0 .19-.056.372a.96.96 0 0 1-.235.414c-.124.124-.317.234-.552.33-.235.097-.581.139-1.009.139-.429 0-.774-.056-1.009-.152-.249-.097-.443-.22-.567-.358a1.05 1.05 0 0 1-.249-.428 1.3 1.3 0 0 1-.055-.344v-9.36c0-.233-.056-.44-.166-.606-.111-.179-.29-.261-.553-.261a.9.9 0 0 0-.346.068 1.2 1.2 0 0 0-.317.207l-.249-.303c.179-.152.401-.303.622-.455q.36-.225.746-.4a4 4 0 0 1 .857-.275 4.4 4.4 0 0 1 .968-.11c.345 0 .649.04.898.137.221.085.427.207.608.359q.223.22.373.496.138.268.194.565c.041.193.069.372.083.551z"
		></path>
	</svg>
);
// new icons.
export const Arrow = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={ 20 } height={ 20 }>
			<path d="m5.39 5.382.057 1.6 6.708-.244-7.664 7.664 1.132 1.13 7.666-7.665-.246 6.712 1.6.056.35-9.601-9.603.348Z" />
		</svg>
	);
};
export const DocIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={ 24 }
			height={ 24 }
			fill="none"
		>
			<path
				fill="#F26C0D"
				d="M1.636 14.182h3.782a.391.391 0 0 0 .364-.364.364.364 0 0 0-.364-.364H1.636a.364.364 0 0 0-.363.364c0 .218.181.364.363.364ZM3.527 19.6a.364.364 0 0 0-.364.363c0 .218.146.364.364.364h7.709l-2.4-.727h-5.31ZM2.945 12c0 .182.146.364.364.364h3.745l.218-.655c-.072-.072-.145-.072-.218-.072H3.31c-.218 0-.364.145-.364.363ZM5.709 16.727l.036-.109H.727a.391.391 0 0 0-.364.364c0 .218.182.364.364.364h4.91c0-.182.036-.4.072-.619ZM1.636 10.509h3.782a.391.391 0 0 0 .364-.364.391.391 0 0 0-.364-.363H1.636a.391.391 0 0 0-.363.363c0 .182.181.364.363.364ZM13.745 4.8l.727-2.4L10.4 4.582l2.4.727c.4.146.837-.073.946-.509Z"
			/>
			<path
				fill="#F26C0D"
				d="M23.529 5.273a1.22 1.22 0 0 0-.655-.546L15.238 2.4l-.8 2.582c-.255.8-1.091 1.236-1.855.982l-2.582-.8-3.563 11.709c-.073.29-.037.581.072.836.146.255.364.436.655.545l10.618 3.237c.11.036.218.036.327.036.473 0 .91-.29 1.055-.764l4.473-14.69c.036-.255 0-.546-.11-.8Zm-6.182 13.309a.395.395 0 0 1-.437.254l-7.527-2.29a.395.395 0 0 1-.254-.437.395.395 0 0 1 .436-.255l7.527 2.255c.218.073.327.29.255.473Zm.69-2.328a.395.395 0 0 1-.436.255l-7.527-2.291a.395.395 0 0 1-.255-.436.395.395 0 0 1 .437-.255l7.563 2.291c.182.037.291.255.219.437Zm.728-2.327a.395.395 0 0 1-.437.255l-7.527-2.291a.395.395 0 0 1-.254-.437.395.395 0 0 1 .436-.254l7.527 2.29c.182.037.291.255.255.437Zm.69-2.327a.395.395 0 0 1-.436.255l-7.527-2.291a.395.395 0 0 1-.254-.437.395.395 0 0 1 .436-.254l7.527 2.29a.323.323 0 0 1 .255.437Zm.728-2.291c-.036.146-.182.255-.364.255h-.109l-7.527-2.291a.395.395 0 0 1-.255-.437.395.395 0 0 1 .437-.254l7.527 2.29c.218.037.327.219.291.437Zm.69-2.327a.395.395 0 0 1-.435.254l-4.182-1.272A.395.395 0 0 1 16 5.527c.037-.181.255-.29.437-.254l4.181 1.273c.218.036.328.218.255.436Z"
			/>
		</svg>
	);
};
export const SupportIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={ 24 }
			height={ 24 }
			fill="none"
		>
			<path
				fill="#F26C0D"
				d="M7.97 9.06c.104.028.215.044.33.044h.225c.018 0 .036-.003.055-.004.601 1.88 1.905 3.186 3.42 3.186 1.368 0 2.563-1.065 3.226-2.655.225-.16.419-.338.569-.533.073-.006.144-.015.213-.033.517-.127.898-.568.898-1.093v-.889c0-.526-.381-.966-.898-1.094V4.977c0-2.083-1.803-3.777-4.02-3.777-2.216 0-4.019 1.694-4.019 3.777v1.018c-.505.135-.875.57-.875 1.088v.888c0 .519.37.954.875 1.09Zm4.018-7.072c1.58 0 2.89 1.088 3.136 2.507-.685-1.042-1.828-1.726-3.124-1.726-1.314 0-2.473.704-3.154 1.773.225-1.442 1.547-2.554 3.142-2.554ZM8.808 7.54c.128.042.275.109.432.22 0 0-.375-2.23.417-2.541 0 0 1.094.53 2.344.565 1.25-.034 2.343-.565 2.343-.565.792.312.416 2.54.416 2.54.148-.103.287-.17.41-.212v.735a6.155 6.155 0 0 1-.27.927c-.508.353-1.234.603-2.05.673a.523.523 0 0 0-.44-.24h-.697a.525.525 0 1 0 0 1.05h.697a.52.52 0 0 0 .463-.283 5.306 5.306 0 0 0 1.636-.384c-.609 1.027-1.505 1.68-2.508 1.68-1.524 0-2.804-1.501-3.193-3.544v-.62Z"
			/>
			<path
				fill="#F26C0D"
				d="M20.354 16.28h-.765a5.026 5.026 0 0 0-4.301-4.487l-.026-.003a6.31 6.31 0 0 0-.212-.024l-.002.021-.007.062a1.02 1.02 0 0 1-.103.343c-.37.93-1.565 2.69-2.268 3.691l-.145-2.078c.205-.105.382-.28.495-.482a.959.959 0 0 0 .132-.467s-.525.233-1.06.233c-.031 0-.062 0-.093-.002-.03.002-.06.002-.091.002-.536 0-1.061-.233-1.061-.233 0 .163.05.322.131.467.114.202.29.376.496.482l-.145 2.078c-.704-1-1.899-2.762-2.268-3.691a1.013 1.013 0 0 1-.103-.343c-.003-.02-.006-.04-.007-.062 0-.007-.003-.014-.003-.02-.071.006-.14.014-.21.023l-.027.003A5.026 5.026 0 0 0 4.41 16.28h-.765c-.9 0-1.63.731-1.63 1.63v3.26c0 .9.73 1.63 1.63 1.63h16.71c.898 0 1.63-.73 1.63-1.63v-3.26c0-.899-.732-1.63-1.63-1.63Zm.815 4.89c0 .45-.365.815-.815.815H3.644a.815.815 0 0 1-.814-.815v-3.26c0-.45.365-.816.815-.816h16.71c.45 0 .815.365.815.815v3.26Z"
			/>
			<path
				fill="#F26C0D"
				d="m13.195 19.194-.6-.088a.374.374 0 0 1-.25-.18l-.268-.545c-.042-.085-.111-.085-.153 0l-.27.545a.37.37 0 0 1-.247.18l-.602.088c-.094.013-.115.08-.047.145l.206.2.229.224a.37.37 0 0 1 .095.292l-.103.6c-.016.093.04.134.124.09l.538-.283a.367.367 0 0 1 .306 0l.538.282c.085.045.14.004.124-.09l-.102-.599a.37.37 0 0 1 .095-.292l.23-.224.204-.2c.069-.066.048-.132-.047-.145ZM9.816 19.194l-.602-.088a.374.374 0 0 1-.248-.18l-.269-.545c-.042-.085-.111-.085-.153 0l-.27.545a.371.371 0 0 1-.247.18l-.602.088c-.094.013-.115.08-.047.145l.168.164.267.26a.37.37 0 0 1 .095.292l-.103.6c-.016.093.04.134.124.09l.538-.283a.367.367 0 0 1 .306 0l.538.282c.085.045.14.004.124-.09l-.102-.599a.37.37 0 0 1 .094-.292l.23-.224.205-.2c.07-.066.048-.132-.046-.145ZM6.436 19.194l-.601-.088a.374.374 0 0 1-.249-.18l-.269-.545c-.042-.085-.11-.085-.153 0l-.143.29-.126.255a.37.37 0 0 1-.248.18l-.601.087c-.095.014-.115.08-.047.146l.435.424a.37.37 0 0 1 .095.292l-.103.6c-.017.093.04.134.124.089l.538-.282a.367.367 0 0 1 .306 0l.538.282c.084.045.14.004.124-.09l-.103-.599a.37.37 0 0 1 .095-.292l.408-.397.027-.026c.068-.067.047-.133-.047-.146ZM16.576 19.194l-.602-.088a.374.374 0 0 1-.249-.18l-.268-.545c-.043-.085-.111-.085-.154 0l-.269.545a.371.371 0 0 1-.248.18l-.6.088c-.095.013-.116.08-.048.145l.205.2.23.224a.37.37 0 0 1 .095.292l-.103.6c-.016.093.04.134.124.09l.538-.283a.367.367 0 0 1 .306 0l.538.282c.084.045.14.004.124-.09l-.102-.599a.37.37 0 0 1 .094-.292l.268-.26.167-.164c.069-.066.047-.132-.046-.145ZM19.955 19.194l-.601-.088a.373.373 0 0 1-.249-.18l-.126-.255-.143-.29c-.042-.085-.11-.085-.153 0l-.27.545a.37.37 0 0 1-.247.18l-.601.088c-.095.014-.115.08-.048.146l.028.026.407.397a.37.37 0 0 1 .095.292l-.103.6c-.016.093.04.134.125.09l.538-.283a.367.367 0 0 1 .306 0l.538.282c.084.045.14.004.124-.09l-.103-.599a.37.37 0 0 1 .095-.292l.435-.424c.068-.066.047-.132-.047-.145Z"
			/>
		</svg>
	);
};
export const TeamIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={ 24 }
			height={ 24 }
			fill="none"
		>
			<path
				fill="#F26C0D"
				d="M16.249 4.129a.487.487 0 0 0-.408-.024l-.024.024a.56.56 0 0 0-.168.168l-.984 1.632c-.048.096-.072.216-.048.336.024.12.096.216.192.264a.458.458 0 0 0 .432 0 .56.56 0 0 0 .168-.168l.984-1.632c.048-.096.072-.216.048-.336a.505.505 0 0 0-.192-.264ZM7.344 4.129a.487.487 0 0 1 .408-.024l.024.024a.56.56 0 0 1 .168.168l.984 1.632c.048.096.072.216.048.336a.371.371 0 0 1-.192.264.458.458 0 0 1-.432 0 .56.56 0 0 1-.168-.168L7.2 4.729c-.048-.096-.072-.216-.048-.336a.503.503 0 0 1 .192-.264ZM5.305 8.544c.048 0 .072 0 .12-.024a.371.371 0 0 0 .264-.192.436.436 0 0 0-.168-.6l-1.656-.96a.387.387 0 0 0-.216-.072h-.024c-.144 0-.264.096-.36.216-.048.096-.072.216-.048.336.024.12.096.216.192.264l1.656.96a.536.536 0 0 0 .24.072ZM20.472 6.936a.414.414 0 0 0-.36-.216h-.023a.387.387 0 0 0-.217.072l-1.656.96a.483.483 0 0 0-.216.264c-.024.12-.024.24.048.336.072.144.216.216.384.216.072 0 .144-.024.216-.048l1.656-.96a.372.372 0 0 0 .192-.264c.048-.144.048-.264-.024-.36ZM11.856 3.192a.423.423 0 0 0-.36.192l-.024.024c-.048.072-.048.144-.048.216l-.024 1.92c0 .12.048.216.12.312a.387.387 0 0 0 .312.144c.168 0 .312-.072.384-.216a.387.387 0 0 0 .072-.216l.024-1.92a.506.506 0 0 0-.12-.312c-.12-.096-.216-.144-.336-.144ZM6.48 18.504V21h11.088v-2.496a2.654 2.654 0 0 0-2.688-2.688H9.192c-1.464 0-2.712 1.2-2.712 2.688ZM12.024 14.712a3.104 3.104 0 0 0 3.096-3.096 3.104 3.104 0 0 0-3.096-3.096 3.104 3.104 0 0 0-3.096 3.096c.024 1.704 1.392 3.096 3.096 3.096ZM4.8 15.168a2.433 2.433 0 0 0 2.424-2.424c0-1.32-1.08-2.448-2.424-2.448a2.458 2.458 0 0 0-2.448 2.448c0 1.344 1.104 2.424 2.448 2.424ZM19.272 15.168a2.433 2.433 0 0 0 2.424-2.424c0-1.32-1.104-2.424-2.424-2.424a2.433 2.433 0 0 0-2.424 2.424c0 1.32 1.08 2.424 2.424 2.424ZM2.544 16.056a2.115 2.115 0 0 0-2.112 2.112v1.968h5.184v-1.608c0-1.008.456-1.896 1.152-2.472H2.544ZM21.504 16.056h-4.176a3.253 3.253 0 0 1 1.128 2.472v1.608h5.184v-1.968c0-1.176-.936-2.112-2.136-2.112Z"
			/>
		</svg>
	);
};
export const WpIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={ 17 } height={ 16 }>
			<path
				// fill="#6E6A69"
				d="M16.5 8c0-4.408-3.592-8-8-8-4.416 0-8 3.592-8 8 0 4.416 3.584 8 8 8 4.408 0 8-3.584 8-8Zm-9.776 4.296-2.728-7.32c.44-.016.936-.064.936-.064.4-.048.352-.904-.048-.888 0 0-1.16.088-1.896.088-.144 0-.296 0-.464-.008A7.097 7.097 0 0 1 8.5.888c1.864 0 3.56.696 4.84 1.872-.544-.088-1.32.312-1.32 1.264 0 .592.36 1.088.72 1.68.28.488.44 1.088.44 1.968 0 1.192-1.12 4-1.12 4L9.636 4.976c.432-.016.656-.136.656-.136.4-.04.352-1-.048-.976 0 0-1.152.096-1.904.096-.696 0-1.864-.096-1.864-.096-.4-.024-.448.96-.048.976l.736.064 1.008 2.728-1.448 4.664ZM14.428 8c.192-.512.592-1.496.344-3.4.56 1.032.84 2.168.84 3.4 0 2.632-1.384 4.992-3.52 6.224.776-2.072 1.552-4.16 2.336-6.224ZM5.38 14.472C2.996 13.32 1.388 10.824 1.388 8c0-1.04.184-1.984.576-2.872C3.1 8.24 4.236 11.36 5.38 14.472Zm3.224-5.304 2.064 5.584a6.734 6.734 0 0 1-2.168.36 6.301 6.301 0 0 1-1.832-.264c.648-1.904 1.296-3.792 1.936-5.68Z"
			/>
		</svg>
	);
};

export const APIKeyIcon = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.83398 7.99676V9.69376C2.83398 11.8582 2.83398 12.9404 3.4247 13.6734C3.54404 13.8215 3.67886 13.9564 3.82687 14.0758C4.55952 14.6668 5.6412 14.6668 7.80452 14.6668C8.27492 14.6668 8.51005 14.6668 8.72545 14.5908C8.77025 14.575 8.81412 14.5568 8.85698 14.5363C9.06305 14.4377 9.22932 14.2713 9.56192 13.9386L12.7196 10.7792C13.105 10.3937 13.2977 10.2009 13.3992 9.95576C13.5007 9.71056 13.5007 9.43796 13.5007 8.8927V6.66279C13.5007 4.14736 13.5007 2.88965 12.7196 2.1082C12.0987 1.48698 11.1769 1.35961 9.56192 1.3335M8.83398 14.3333V13.9998C8.83398 12.1132 8.83398 11.17 9.41978 10.5839C10.0056 9.99783 10.9484 9.99783 12.834 9.99783H13.1673"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M2.83398 4.44461C2.83398 5.30372 3.50556 6.00016 4.33398 6.00016H7.48398C8.22958 6.00016 8.83398 5.37336 8.83398 4.60016C8.83398 3.82696 8.22285 3.20018 7.47725 3.20018C7.56045 2.24305 6.8206 1.3335 5.83398 1.3335C4.97096 1.3335 4.26268 2.02062 4.19011 2.89612C3.42918 2.97121 2.83398 3.63582 2.83398 4.44461Z"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const AdvancedIcon = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.83398 13.3335H14.5007"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.16602 3.3335L14.4993 3.3335"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M2.5 3.3335H5.16667"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M2.5 8.3335H9.16667"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M2.5 13.3335H3.83333"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M13.166 8.3335H14.4993"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.83398 14.6665C6.52336 14.6665 6.36804 14.6665 6.24553 14.6158C6.08218 14.5481 5.95239 14.4183 5.88473 14.255C5.83398 14.1324 5.83398 13.9771 5.83398 13.6665V12.9998C5.83398 12.6892 5.83398 12.5339 5.88473 12.4114C5.95239 12.248 6.08218 12.1182 6.24553 12.0506C6.36804 11.9998 6.52336 11.9998 6.83398 11.9998C7.14461 11.9998 7.29992 11.9998 7.42245 12.0506C7.58578 12.1182 7.71558 12.248 7.78325 12.4114C7.83398 12.5339 7.83398 12.6892 7.83398 12.9998V13.6665C7.83398 13.9771 7.83398 14.1324 7.78325 14.255C7.71558 14.4183 7.58578 14.5481 7.42245 14.6158C7.29992 14.6665 7.14461 14.6665 6.83398 14.6665Z"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.16602 4.6665C7.85542 4.6665 7.70008 4.6665 7.57755 4.61577C7.41422 4.5481 7.28442 4.4183 7.21675 4.25497C7.16602 4.13244 7.16602 3.9771 7.16602 3.6665V2.99984C7.16602 2.68924 7.16602 2.5339 7.21675 2.41137C7.28442 2.24804 7.41422 2.11824 7.57755 2.05057C7.70008 1.99984 7.85542 1.99984 8.16602 1.99984C8.47662 1.99984 8.63195 1.99984 8.75448 2.05057C8.91782 2.11824 9.04762 2.24804 9.11528 2.41137C9.16602 2.5339 9.16602 2.68924 9.16602 2.99984V3.6665C9.16602 3.9771 9.16602 4.13244 9.11528 4.25497C9.04762 4.4183 8.91782 4.5481 8.75448 4.61577C8.63195 4.6665 8.47662 4.6665 8.16602 4.6665Z"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.166 9.6665C9.85542 9.6665 9.70008 9.6665 9.57755 9.61576C9.41422 9.5481 9.28442 9.41831 9.21675 9.25497C9.16602 9.13244 9.16602 8.9771 9.16602 8.6665V7.99984C9.16602 7.68924 9.16602 7.5339 9.21675 7.41137C9.28442 7.24804 9.41422 7.11824 9.57755 7.05057C9.70008 6.99984 9.85542 6.99984 10.166 6.99984C10.4766 6.99984 10.6319 6.99984 10.7545 7.05057C10.9178 7.11824 11.0476 7.24804 11.1153 7.41137C11.166 7.5339 11.166 7.68924 11.166 7.99984V8.6665C11.166 8.9771 11.166 9.13244 11.1153 9.25497C11.0476 9.41831 10.9178 9.5481 10.7545 9.61576C10.6319 9.6665 10.4766 9.6665 10.166 9.6665Z"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const AdditionalCodesIcon = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.5 6.6665L11.3177 7.3713C11.6615 7.66757 11.8333 7.81577 11.8333 7.99984C11.8333 8.1839 11.6615 8.3321 11.3177 8.62837L10.5 9.33317"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5.16634 6.6665L4.34865 7.3713C4.00489 7.66757 3.83301 7.81577 3.83301 7.99984C3.83301 8.1839 4.00489 8.3321 4.34865 8.62837L5.16634 9.33317"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.50033 6L7.16699 10"
			stroke="#2F2F2F"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M1.5 7.99984C1.5 5.01428 1.5 3.5215 2.42749 2.594C3.35499 1.6665 4.84777 1.6665 7.83333 1.6665C10.8189 1.6665 12.3117 1.6665 13.2392 2.594C14.1667 3.5215 14.1667 5.01428 14.1667 7.99984C14.1667 10.9854 14.1667 12.4782 13.2392 13.4057C12.3117 14.3332 10.8189 14.3332 7.83333 14.3332C4.84777 14.3332 3.35499 14.3332 2.42749 13.4057C1.5 12.4782 1.5 10.9854 1.5 7.99984Z"
			stroke="#2F2F2F"
		/>
	</svg>
);

export const KeyIcon = () => (
	<svg
		width={ 20 }
		height={ 20 }
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M12.9163 12.0835C15.6778 12.0835 17.9163 9.84491 17.9163 7.0835C17.9163 4.32207 15.6778 2.0835 12.9163 2.0835C10.1549 2.0835 7.91634 4.32207 7.91634 7.0835C7.91634 7.81717 8.07436 8.51391 8.35826 9.14158L2.08301 15.4168V17.9168H4.58301V16.2502H6.24967V14.5835H7.91634L10.8583 11.6416C11.4859 11.9255 12.1827 12.0835 12.9163 12.0835Z"
			stroke="#1A74E4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.5833 5.4165L13.75 6.24984"
			stroke="#1A74E4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const ProIconFill = () => (
	<svg
		width={ 14 }
		height={ 14 }
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.29413 9.17787C2.07639 7.448 1.85865 5.71816 1.6409 3.98829C1.59262 3.60482 1.9496 3.34328 2.20354 3.57608C2.88193 4.19794 3.56029 4.81976 4.23869 5.44162C4.46205 5.64637 4.78027 5.57974 4.93512 5.2958L6.62943 2.18955C6.80848 1.8613 7.20309 1.8613 7.38214 2.18955L9.07644 5.2958C9.23129 5.57974 9.54952 5.64633 9.77288 5.44162C10.4513 4.81976 11.1296 4.19794 11.808 3.57608C12.062 3.34328 12.419 3.60482 12.3707 3.98829C12.153 5.71816 11.9352 7.448 11.7175 9.17787H2.29413Z"
			fill="white"
		/>
		<path
			d="M11.2259 12.0572H2.78524C2.51391 12.0572 2.29395 11.7884 2.29395 11.4568V10.1377H11.7173V11.4568C11.7172 11.7884 11.4973 12.0572 11.2259 12.0572Z"
			fill="white"
		/>
	</svg>
);
export const ProIconLight = () => (
	<svg
		width={16}
		height={16}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
		d="M10.217 6.017c.188.345.505.604.893.685.395.083.798-.034 1.103-.313l1.378-1.263.959-.88-.759 6.027H2.223l-.76-6.027.96.88 1.379 1.263c.305.28.708.396 1.102.313a1.34 1.34 0 0 0 .893-.685l2.21-4.052z"
		stroke="#fff"
		strokeWidth={1.355}
		/>
		<path
		d="M13.723 14.85H2.29c-.367 0-.665-.364-.665-.813V12.25h12.764v1.787c0 .449-.298.813-.666.813"
		fill="#fff"
		/>
	</svg>
);

export const DocsStroked = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_21217_9317)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.46094 10.7544C9.22699 10.7546 9.84723 11.376 9.84766 12.1411C9.84766 12.9065 9.22728 13.5286 8.46094 13.5288C7.69448 13.5288 7.07324 12.9066 7.07324 12.1411C7.07367 11.3759 7.69477 10.7544 8.46094 10.7544ZM8.46094 11.688C8.21058 11.688 8.00726 11.891 8.00684 12.1411C8.00684 12.3916 8.21034 12.5952 8.46094 12.5952C8.71142 12.595 8.91406 12.3914 8.91406 12.1411C8.91364 11.8911 8.71118 11.6882 8.46094 11.688Z"
				fill="#565A5F"
			/>
			<path
				d="M4.77832 11.6753C5.03605 11.6753 5.24512 11.8844 5.24512 12.1421C5.24501 12.3997 5.03599 12.6089 4.77832 12.6089H2.9375C2.67985 12.6089 2.47081 12.3997 2.4707 12.1421C2.4707 11.8844 2.67979 11.6753 2.9375 11.6753H4.77832Z"
				fill="#565A5F"
			/>
			<path
				d="M9.38086 8.91357C9.63857 8.91357 9.84763 9.12266 9.84766 9.38037C9.84766 9.6381 9.63859 9.84717 9.38086 9.84717H2.9375C2.67979 9.84714 2.4707 9.63809 2.4707 9.38037C2.47073 9.12268 2.67981 8.9136 2.9375 8.91357H9.38086Z"
				fill="#565A5F"
			/>
			<path
				d="M8 7.07275C8.25773 7.07275 8.4668 7.28182 8.4668 7.53955C8.46675 7.79724 8.2577 8.00635 8 8.00635H2.9375C2.67982 8.00632 2.47075 7.79722 2.4707 7.53955C2.4707 7.28183 2.67979 7.07278 2.9375 7.07275H8Z"
				fill="#565A5F"
			/>
			<path
				d="M9.38086 5.23193C9.63859 5.23193 9.84766 5.441 9.84766 5.69873C9.84753 5.95635 9.63851 6.16553 9.38086 6.16553H2.9375C2.67987 6.1655 2.47083 5.95634 2.4707 5.69873C2.4707 5.44101 2.67979 5.23196 2.9375 5.23193H9.38086Z"
				fill="#565A5F"
			/>
			<path
				d="M8 2.93018C8.25763 2.93018 8.46664 3.13938 8.4668 3.39697C8.4668 3.65471 8.25773 3.86377 8 3.86377H4.31836C4.06065 3.86374 3.85156 3.65469 3.85156 3.39697C3.85172 3.13939 4.06075 2.9302 4.31836 2.93018H8Z"
				fill="#565A5F"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.1426 0.629395C12.5098 0.629506 12.8629 0.775663 13.123 1.03564L13.2158 1.13721C13.4181 1.38419 13.5292 1.69469 13.5293 2.01611V2.93701C13.5293 3.19474 13.3202 3.40381 13.0625 3.40381H11.6885V14.9038C11.6882 15.1613 11.4792 15.3705 11.2217 15.3706H1.09668C0.839092 15.3706 0.630119 15.1613 0.629883 14.9038V2.01709C0.629883 1.6497 0.775907 1.29704 1.03613 1.03662C1.29639 0.776532 1.6503 0.629395 2.01758 0.629395H12.1426ZM2.01758 1.56299C1.89732 1.56299 1.78115 1.61111 1.69629 1.6958C1.61154 1.78064 1.56348 1.89633 1.56348 2.01709V14.437H10.7549V2.01611C10.7549 1.93008 10.7637 1.8457 10.7793 1.76416C10.792 1.69515 10.8095 1.62802 10.832 1.56299H2.01758ZM12.1426 1.56299C12.0174 1.56305 11.9044 1.61395 11.8223 1.6958C11.7606 1.7573 11.7165 1.83586 11.6982 1.92432C11.6921 1.95396 11.6885 1.98465 11.6885 2.01611V2.47021H12.5957V2.01611C12.5956 1.89559 12.5483 1.78049 12.4639 1.6958C12.379 1.61105 12.2628 1.5631 12.1426 1.56299Z"
				fill="#565A5F"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.9834 4.31104C14.3505 4.31115 14.7037 4.45747 14.9639 4.71729L15.0566 4.81885C15.2588 5.06575 15.3699 5.37648 15.3701 5.69775V13.5229C15.37 13.6148 15.3429 13.7053 15.292 13.7817L14.3711 15.1626C14.2846 15.292 14.1391 15.3705 13.9834 15.3706C13.8664 15.3705 13.7546 15.3262 13.6699 15.2495L13.5947 15.1626L12.6738 13.7817C12.6229 13.7053 12.5958 13.6148 12.5957 13.5229V5.69775C12.5961 4.93222 13.2175 4.31127 13.9834 4.31104ZM13.5293 13.3823L13.9824 14.063L14.4365 13.3833V7.08643H13.5293V13.3823ZM13.9834 5.24463C13.7331 5.24487 13.5297 5.44753 13.5293 5.69775V6.15186H14.4365V5.69775C14.4363 5.57738 14.3891 5.46205 14.3047 5.37744C14.2199 5.29286 14.1035 5.24474 13.9834 5.24463Z"
				fill="#565A5F"
			/>
		</g>
		<defs>
			<clipPath id="clip0_21217_9317">
				<rect width={ 16 } height={ 16 } fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const TechSupport = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_21217_9324)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.99993 0.5C10.9174 0.500253 13.3116 2.73401 13.5683 5.58475H14.2287C15.2114 5.58501 16.0084 6.38171 16.0084 7.36441V9.90678C16.0082 10.8893 15.2112 11.6862 14.2287 11.6864H13.5495C13.3072 13.1289 12.0536 14.2286 10.5423 14.2288H9.70411C9.48514 14.9634 8.80564 15.4998 7.99993 15.5C7.01718 15.5 6.22049 14.703 6.22027 13.7203C6.22027 12.7375 7.01705 11.9407 7.99993 11.9407C8.80591 11.9409 9.48538 12.4769 9.70411 13.2119H10.5423C11.5952 13.2116 12.4611 12.411 12.5653 11.3855L12.5762 11.178V6.09322C12.5762 3.56597 10.5271 1.51722 7.99993 1.51695C5.47251 1.51695 3.42366 3.5658 3.42366 6.09322V11.178C3.42344 11.4584 3.19564 11.6862 2.91518 11.6864H1.77112C0.788383 11.6864 -0.00832685 10.8895 -0.00854492 9.90678V7.36441C-0.00854492 6.38154 0.788249 5.58475 1.77112 5.58475H2.43054C2.68731 2.73385 5.08218 0.5 7.99993 0.5ZM7.99993 12.9576C7.5787 12.9576 7.23722 13.2991 7.23722 13.7203C7.23744 14.1414 7.57883 14.4831 7.99993 14.4831C8.4208 14.4828 8.76242 14.1412 8.76264 13.7203C8.76264 13.2993 8.42094 12.9579 7.99993 12.9576ZM1.77112 6.6017C1.34989 6.6017 1.0084 6.94319 1.0084 7.36441V9.90678C1.00862 10.3278 1.35003 10.6695 1.77112 10.6695H2.40671V6.6017H1.77112ZM13.5932 10.6695H14.2287C14.6496 10.6692 14.9912 10.3277 14.9915 9.90678V7.36441C14.9915 6.94335 14.6497 6.60196 14.2287 6.6017H13.5932V10.6695Z"
				fill="#565A5F"
			/>
		</g>
		<defs>
			<clipPath id="clip0_21217_9324">
				<rect width={ 16 } height={ 16 } fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const SetupWizard = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.073 2.61a.5.5 0 0 1 .524.046L9.614 4.17l2.395-.816a.498.498 0 0 1 .632.632l-.816 2.394L13.34 8.4a.498.498 0 0 1-.403.797l-2.524-.027-1.472 2.066a.498.498 0 0 1-.882-.142l-.267-.866-5.348 5.35a1.432 1.432 0 0 1-2.025-2.025l5.349-5.349-.865-.266a.498.498 0 0 1-.142-.882l2.066-1.473L6.8 3.059a.5.5 0 0 1 .273-.45m-5.95 11.646a.436.436 0 0 0 .617.617L7.46 9.15l-.145-.47-.47-.146zm10.142-1.621v-.436h-.435a.498.498 0 0 1 0-.995h.435v-.436a.498.498 0 0 1 .997 0v.436h.435a.498.498 0 1 1 0 .995h-.435v.436a.498.498 0 0 1-.997 0M7.826 5.83a.5.5 0 0 1-.208.41L6.159 7.28l.687.212.003.001 1.012.313.058.021c.13.058.229.17.271.308l.31 1.009.003.009.211.684 1.04-1.458.038-.046a.5.5 0 0 1 .373-.162l1.772.018-1.066-1.42a.5.5 0 0 1-.074-.46l.574-1.684-1.685.574a.5.5 0 0 1-.46-.074L7.806 4.06zm6.241 1.202v-.435h-.435a.498.498 0 0 1 0-.996h.435v-.436a.498.498 0 0 1 .996 0v.436h.436a.498.498 0 0 1 0 .996h-.436v.435a.498.498 0 0 1-.996 0M3.796 5.166V4.73h-.435a.498.498 0 0 1 0-.996h.436V3.3a.498.498 0 0 1 .995 0v.435h.436a.498.498 0 0 1 0 .996h-.436v.436a.498.498 0 1 1-.995 0m5.602-2.8V1.93h-.435a.498.498 0 0 1 0-.996h.435V.498a.498.498 0 0 1 .996 0v.436h.436a.498.498 0 0 1 0 .996h-.436v.435a.498.498 0 0 1-.996 0"
			fill="#565a5f"
		/>
	</svg>
);

export const Roadmap = () => (
	<svg
		width={ 13 }
		height={ 16 }
		viewBox="0 0 13 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9 12.667H12V11H9V12.667ZM1 10.667H4V9H1V10.667ZM9 6.66699H12V5H9V6.66699ZM1 4.66699H4V3H1V4.66699ZM5 3.33301H6V0.5C6 0.223858 6.22386 0 6.5 0C6.77614 0 7 0.223858 7 0.5V5.33301H8V4.83301C8.00018 4.37303 8.37303 4.00018 8.83301 4H12.167C12.627 4.00018 12.9998 4.37303 13 4.83301V6.83301C13 7.29314 12.6271 7.66682 12.167 7.66699H8.83301C8.37292 7.66682 8 7.29314 8 6.83301V6.33301H7V11.333H8V10.833C8.00018 10.373 8.37303 10.0002 8.83301 10H12.167C12.627 10.0002 12.9998 10.373 13 10.833V12.833C13 13.2931 12.6271 13.6668 12.167 13.667H8.83301C8.37292 13.6668 8 13.2931 8 12.833V12.333H7V15.167C6.99982 15.443 6.77603 15.667 6.5 15.667C6.22397 15.667 6.00018 15.443 6 15.167V10.333H5V10.833C5 11.2931 4.62708 11.6668 4.16699 11.667H0.833008C0.372921 11.6668 0 11.2931 0 10.833V8.83301C0.000176177 8.37303 0.373028 8.00018 0.833008 8H4.16699C4.62697 8.00018 4.99982 8.37303 5 8.83301V9.33301H6V4.33301H5V4.83301C5 5.29314 4.62708 5.66682 4.16699 5.66699H0.833008C0.37292 5.66682 0 5.29314 0 4.83301V2.83301C0.000175919 2.37303 0.373028 2.00018 0.833008 2H4.16699C4.62697 2.00018 4.99982 2.37303 5 2.83301V3.33301Z"
			fill="#565A5F"
		/>
	</svg>
);

export const FeatRequest = () => (
	<svg
		width={ 15 }
		height={ 13 }
		viewBox="0 0 15 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.5844 0C14.0866 0.00036694 14.5 0.40801 14.5 0.913763V6.85187C14.4998 7.35793 14.0853 7.76526 13.5844 7.76563H13.3142V9.36359C13.3141 9.53876 13.2142 9.6992 13.0575 9.77754C12.9008 9.85571 12.7131 9.83828 12.5731 9.73325L9.95378 7.76563H4.60494C4.34958 7.76555 4.25024 7.55819 4.25 7.30287C4.25 7.04735 4.42774 6.8402 4.68324 6.84012H10.1074C10.2076 6.84018 10.3057 6.87217 10.3858 6.93231L12.3887 8.43807V7.30287C12.3887 7.0473 12.5959 6.84012 12.8514 6.84012H13.5745V0.925513H2.932V6.84012H4.74054C4.99578 6.84051 5.2033 7.04754 5.2033 7.30287C5.20306 7.558 4.99563 7.76523 4.74054 7.76563H2.92205C2.41939 7.76563 2.00665 7.35589 2.00648 6.85187V3.82497H0.925513V9.1295H2.26588C2.52133 9.12957 2.72854 9.33681 2.72864 9.59225V10.7275L4.7306 9.22259C4.81073 9.16244 4.90878 9.1295 5.00898 9.1295H10.0975C10.3529 9.12957 10.5601 9.33681 10.5602 9.59225C10.5602 9.84772 10.353 10.0549 10.0975 10.055H5.16263L2.54426 12.0226C2.40408 12.128 2.21577 12.1452 2.0589 12.0669C1.90218 11.9885 1.80312 11.8282 1.80312 11.653V10.055H0.915571C0.413233 10.0548 0 9.64711 0 9.14124V3.81232C0.000100153 3.30683 0.413768 2.89963 0.915571 2.89946H2.00648V0.913763C2.00649 0.408306 2.41983 0 2.92205 0H13.5844Z"
			fill="#565A5F"
		/>
	</svg>
);

export const Video = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.13145 13.3764C1.13145 14.2004 1.79963 14.8686 2.62363 14.8686H13.3764C13.6888 14.8686 13.9421 15.1218 13.9421 15.4343C13.9421 15.7467 13.6888 16 13.3764 16H2.62363C1.17453 16 0 14.8255 0 13.3764V2.62363C0 2.31119 0.253283 2.0579 0.565723 2.0579C0.878163 2.0579 1.13145 2.31119 1.13145 2.62363V13.3764ZM13.9421 0C15.0786 0 16 0.921355 16 2.0579V11.3185C16 12.455 15.0786 13.3764 13.9421 13.3764H4.68153L4.47152 13.3653C3.43364 13.2601 2.62363 12.3841 2.62363 11.3185V2.0579C2.62363 0.921355 3.54498 0 4.68153 0H13.9421ZM4.68153 1.13145C4.17008 1.13145 3.75507 1.54646 3.75507 2.0579V11.3185C3.75507 11.8299 4.17008 12.2449 4.68153 12.2449H13.9421C14.4535 12.2449 14.8686 11.8299 14.8686 11.3185V2.0579C14.8686 1.54646 14.4535 1.13145 13.9421 1.13145H4.68153ZM6.97155 3.6576C7.11489 3.57824 7.29073 3.58294 7.42976 3.66966L11.6732 6.3174C11.8055 6.40003 11.8855 6.54527 11.8852 6.70125C11.8848 6.85726 11.8039 7.00205 11.6712 7.08409L7.42775 9.70772C7.28864 9.79362 7.11339 9.79729 6.97055 9.71777C6.82778 9.63803 6.73943 9.48641 6.73943 9.32287V4.0525C6.7396 3.88869 6.82829 3.73709 6.97155 3.6576ZM7.64178 8.51297L10.5779 6.69824L7.64178 4.86542V8.51297Z"
			fill="#565A5F"
		/>
	</svg>
);

export const WhatsNew = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.9776 7.99978C13.9776 5.116 11.9304 2.70842 9.2081 2.1506L9.31094 1.65095L9.41278 1.15031C12.6012 1.80351 15 4.62136 15 7.99978C14.9999 11.5229 12.3908 14.4353 8.99743 14.9191L9.19812 15.1734C9.37262 15.3947 9.33473 15.7158 9.11325 15.8904C8.89167 16.0649 8.57026 16.0269 8.39538 15.8057L7.59863 14.7974C7.46615 14.6297 7.45225 14.3973 7.56369 14.215L8.23563 13.1189C8.38311 12.8786 8.69783 12.8032 8.93852 12.9504C9.17904 13.0977 9.25459 13.4121 9.10726 13.6525L8.95949 13.8928C11.8045 13.4342 13.9775 10.971 13.9776 7.99978ZM1 7.99978C1 4.47752 3.60757 1.56443 6.99957 1.0795L6.80088 0.828179C6.62574 0.60702 6.66335 0.285088 6.88475 0.110122C7.10616 -0.0648254 7.42846 -0.0272546 7.60362 0.193895L8.40137 1.20117C8.53414 1.36887 8.54784 1.60209 8.43631 1.78459L7.76637 2.88063C7.61923 3.1212 7.30439 3.19707 7.06347 3.05017C6.82269 2.90317 6.74669 2.58869 6.89374 2.34807L7.04051 2.10572C4.19535 2.5643 2.02239 5.02846 2.02239 7.99978C2.02244 10.8835 4.06964 13.2912 6.7919 13.8489L6.58622 14.8492C3.39803 14.1959 1.00005 11.378 1 7.99978ZM5.65968 10.2218V11.243H4.74711V10.2218H5.65968ZM11.2529 10.2218V11.243H6.57125V10.2218H11.2529ZM5.65968 8.39969V9.42093H4.74711V8.39969H5.65968ZM11.2529 8.39969V9.42093H6.57125V8.39969H11.2529ZM5.65968 6.57862V7.59986H4.74711V6.57862H5.65968ZM11.2529 6.57862V7.59986H6.57125V6.57862H11.2529ZM5.65968 4.75655V5.77779H4.74711V4.75655H5.65968ZM11.2529 4.75655V5.77779H6.57125V4.75655H11.2529Z"
			fill="#565A5F"
		/>
	</svg>
);

export const Blog = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M8.65039 8.5791C8.78091 8.45177 8.97104 8.40599 9.14551 8.45898L11.6055 9.20605L11.6631 9.22754C11.7193 9.25247 11.7708 9.28828 11.8145 9.33203L15.2383 12.7627H15.2373C15.9207 13.4461 15.9207 14.5539 15.2373 15.2373C14.5966 15.878 13.5829 15.9181 12.8955 15.3574L12.7627 15.2373L9.34473 11.8135C9.28389 11.7525 9.23981 11.6767 9.2168 11.5938L8.51855 9.07129C8.46988 8.89556 8.51987 8.70644 8.65039 8.5791ZM13.2607 14.3203L13.4697 14.5303L13.5264 14.582C13.8209 14.8223 14.2557 14.8049 14.5303 14.5303C14.8232 14.2373 14.8231 13.7626 14.5303 13.4697V13.4688L14.3213 13.2598L13.2607 14.3203ZM10.1455 11.1992L12.5537 13.6133L13.6152 12.5518L11.1943 10.126L9.72363 9.67969L10.1455 11.1992ZM14.75 10.0625V2.375C14.75 1.61561 14.1344 1 13.375 1H2.375C1.61561 1 1 1.61561 1 2.375V13.375C1 14.1344 1.61561 14.75 2.375 14.75H10.0312C10.3074 14.75 10.5312 14.9739 10.5312 15.25C10.5312 15.5261 10.3074 15.75 10.0312 15.75H2.375C1.06333 15.75 5.15407e-07 14.6867 0 13.375V2.375C0 1.06333 1.06333 0 2.375 0H13.375C14.6867 5.15415e-07 15.75 1.06333 15.75 2.375V10.0625C15.75 10.3386 15.5261 10.5625 15.25 10.5625C14.9739 10.5625 14.75 10.3386 14.75 10.0625ZM6.5 7.90625C6.7761 7.9063 7 8.13014 7 8.40625C6.99999 8.68235 6.77609 8.9062 6.5 8.90625H3.625C3.34886 8.90625 3.12501 8.68239 3.125 8.40625C3.125 8.13011 3.34886 7.90625 3.625 7.90625H6.5ZM12.125 5.40625C12.4011 5.4063 12.625 5.63014 12.625 5.90625C12.625 6.18235 12.4011 6.4062 12.125 6.40625H3.625C3.34886 6.40625 3.12501 6.18239 3.125 5.90625C3.125 5.63011 3.34886 5.40625 3.625 5.40625H12.125ZM12.125 2.90625C12.4011 2.9063 12.625 3.13014 12.625 3.40625C12.625 3.68235 12.4011 3.9062 12.125 3.90625H3.625C3.34886 3.90625 3.12501 3.68239 3.125 3.40625C3.125 3.13011 3.34886 2.90625 3.625 2.90625H12.125Z"
			fill="#565A5F"
		/>
	</svg>
);

export const Community = () => (
	<svg
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.042 14.5273C10.042 13.4007 9.12664 12.4854 8 12.4854C6.87334 12.4854 5.95801 13.4007 5.95801 14.5273V15.0625H10.042V14.5273ZM9.03711 10.5107C9.03711 9.93841 8.57243 9.47266 8 9.47266C7.42759 9.47267 6.96289 9.93842 6.96289 10.5107C6.96306 11.0831 7.42763 11.5478 8 11.5479C8.57238 11.5479 9.03694 11.0832 9.03711 10.5107ZM5.02051 5.99121C5.02025 4.8649 4.10583 3.95036 2.97949 3.9502C1.85297 3.9502 0.937754 4.8648 0.9375 5.99121V6.52734H5.02051V5.99121ZM5.95801 6.99609C5.95787 7.25486 5.74806 7.46484 5.48926 7.46484H3.05273C2.98287 7.79927 2.9463 8.14612 2.94629 8.50195C2.94629 10.3841 3.97796 12.0274 5.50781 12.8975C5.78106 12.4806 6.15444 12.1348 6.5957 11.8984C6.2431 11.5417 6.02547 11.0516 6.02539 10.5107C6.02539 9.42071 6.90976 8.53517 8 8.53516C9.09026 8.53516 9.97461 9.4207 9.97461 10.5107C9.97453 11.0519 9.75623 11.5417 9.40332 11.8984C9.84476 12.1348 10.2178 12.4806 10.4912 12.8975C12.0215 12.0275 13.0537 10.3844 13.0537 8.50195C13.0537 8.14614 13.0171 7.79927 12.9473 7.46484H10.5107C10.2519 7.46484 10.0421 7.25486 10.042 6.99609V5.99121C10.0421 5.31709 10.2684 4.69665 10.6465 4.19727C9.87654 3.72246 8.97061 3.44824 8 3.44824C7.02909 3.44824 6.12263 3.72218 5.35254 4.19727C5.73087 4.69673 5.9579 5.31687 5.95801 5.99121V6.99609ZM10.9795 6.52734H15.0625V5.99121C15.0622 4.8648 14.147 3.9502 13.0205 3.9502C11.8941 3.95038 10.9797 4.86492 10.9795 5.99121V6.52734ZM4.0166 1.97461C4.01639 1.40256 3.55163 0.937663 2.97949 0.9375C2.40719 0.9375 1.94162 1.40245 1.94141 1.97461C1.94141 2.51132 2.35033 2.95358 2.87305 3.00684L2.97949 3.0127L3.08496 3.00684C3.60783 2.95375 4.0166 2.51144 4.0166 1.97461ZM14.0586 1.97461C14.0584 1.40245 13.5928 0.9375 13.0205 0.9375C12.4484 0.937686 11.9836 1.40257 11.9834 1.97461C11.9834 2.51143 12.3922 2.95373 12.915 3.00684L13.0205 3.0127L13.127 3.00684C13.6497 2.9536 14.0586 2.51134 14.0586 1.97461ZM14.9961 1.97461C14.9961 2.51629 14.7763 3.00639 14.4229 3.36328C15.3609 3.86504 15.9998 4.85385 16 5.99121V6.99609C15.9999 7.25486 15.79 7.46484 15.5312 7.46484H13.8984C13.9575 7.80213 13.9912 8.14833 13.9912 8.50195C13.9912 10.7682 12.7308 12.741 10.875 13.7588C10.9405 14.0042 10.9795 14.2614 10.9795 14.5273V15.5312C10.9795 15.79 10.7695 15.9998 10.5107 16H5.48926C5.23053 15.9998 5.02051 15.79 5.02051 15.5312V14.5273C5.02051 14.2615 5.05856 14.0042 5.12402 13.7588C3.26864 12.7408 2.00879 10.7679 2.00879 8.50195C2.0088 8.14834 2.04253 7.80214 2.10156 7.46484H0.46875C0.209952 7.46484 0.000139104 7.25486 0 6.99609V5.99121C0.000175572 4.85416 0.638542 3.86517 1.57617 3.36328C1.22304 3.00643 1.00391 2.51603 1.00391 1.97461C1.00412 0.884749 1.88936 0 2.97949 0C4.06944 0.000163301 4.95389 0.884844 4.9541 1.97461C4.9541 2.51613 4.73508 3.00642 4.38184 3.36328C4.4768 3.4141 4.56875 3.46981 4.65723 3.53027C5.61228 2.88665 6.76299 2.51074 8 2.51074C9.23672 2.51074 10.3869 2.88693 11.3418 3.53027C11.4305 3.46964 11.523 3.41423 11.6182 3.36328C11.2649 3.00642 11.0459 2.51612 11.0459 1.97461C11.0461 0.884857 11.9306 0.000185742 13.0205 0C14.1106 0 14.9959 0.88475 14.9961 1.97461Z"
			fill="#565A5F"
		/>
	</svg>
);

export const ChangelogIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		fill="none"
		viewBox="0 0 24 24"
	>
		<rect
			width="23"
			height="23"
			x="0.5"
			y="0.5"
			stroke="#fff"
			rx="11.5"
		></rect>
		<g fill="#fff" clipPath="url(#clip0_5063_2041)">
			<path d="M11.563 7.138a.41.41 0 0 0 .41-.41V5.41a.41.41 0 0 0-.82 0v1.318c0 .227.183.41.41.41M15.581 8.562l.932-.932c.37-.398-.182-.95-.58-.58L15 7.982c-.37.398.181.95.58.58M18.153 11.59h-1.318c-.543.02-.543.8 0 .82h1.318c.543-.02.544-.8 0-.82M16.055 10.14c.062.15.273.33.536.221l1.217-.504c.494-.226.196-.947-.314-.758l-1.217.505a.41.41 0 0 0-.222.536M13.423 7.508c.26.108.473-.07.536-.222l.505-1.217a.41.41 0 0 0-.758-.314L13.2 6.972a.41.41 0 0 0 .222.536M9.656 6.877a.412.412 0 0 0-.692.21l-1.1 5.501 3.11 3.111 5.501-1.1a.41.41 0 0 0 .21-.692zM5.925 17.637c.525.525 1.308.62 1.927.3L5.625 15.71a1.65 1.65 0 0 0 .3 1.927M10.589 16.473l-1.52 1.52.887.887c.16.16.42.16.58 0l.94-.94a.41.41 0 0 0 0-.58zM6.148 15.075l1.52-1.52 2.337 2.337-1.52 1.52z"></path>
		</g>
		<defs>
			<clipPath id="clip0_5063_2041">
				<path fill="#fff" d="M5 5h14v14H5z"></path>
			</clipPath>
		</defs>
	</svg>
);

export const GetHelp = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={ 16 }
			height={ 16 }
			fill="none"
		>
			<path
				fill="#fff"
				d="M4.934 7.921c.09.025.184.038.283.038h.193c.016 0 .031-.002.047-.003.515 1.61 1.632 2.728 2.93 2.728 1.17 0 2.194-.912 2.761-2.273.193-.137.36-.29.488-.457.062-.005.124-.013.182-.028.443-.11.77-.486.77-.937v-.76c0-.45-.327-.828-.77-.937v-.867c0-1.784-1.543-3.235-3.442-3.235-1.898 0-3.442 1.451-3.442 3.235v.871c-.432.116-.75.49-.75.932v.761c0 .444.318.817.75.933Zm3.442-6.056c1.352 0 2.475.932 2.685 2.147-.586-.893-1.565-1.478-2.675-1.478-1.126 0-2.118.603-2.702 1.518.193-1.235 1.326-2.187 2.692-2.187ZM5.652 6.62c.11.036.236.093.37.187 0 0-.32-1.908.358-2.175 0 0 .936.454 2.006.484 1.07-.03 2.007-.484 2.007-.484.679.267.357 2.175.357 2.175.127-.088.246-.145.35-.181v.63a5.274 5.274 0 0 1-.23.793c-.436.303-1.057.517-1.757.577a.448.448 0 0 0-.376-.206H8.14a.45.45 0 1 0 0 .899h.597a.446.446 0 0 0 .396-.243c.52-.04.993-.157 1.401-.328-.52.88-1.288 1.439-2.147 1.439-1.305 0-2.401-1.286-2.734-3.036v-.53Z"
			/>
			<path
				fill="#fff"
				fillRule="evenodd"
				d="M14.886 14.104v.413a.285.285 0 0 1-.286.285H2.17a.285.285 0 0 1-.284-.285v-.413a4.305 4.305 0 0 1 3.683-3.842l.01-.001c.004 0 .009 0 .013-.002l.18-.02.002.01v.008l.005.043.002.01c.011.101.04.199.088.293.316.796 1.34 2.305 1.942 3.162l.124-1.78a1.045 1.045 0 0 1-.424-.413.822.822 0 0 1-.112-.4s.45.2.908.2c.026 0 .052 0 .079-.002.026.002.052.002.078.002.459 0 .908-.2.908-.2a.822.822 0 0 1-.112.4 1.04 1.04 0 0 1-.424.413l.124 1.78c.602-.857 1.626-2.365 1.942-3.162a.872.872 0 0 0 .088-.293l.003-.023a.561.561 0 0 0 .004-.039l.001-.009.182.02.012.002.01.001a4.304 4.304 0 0 1 3.684 3.842Z"
				clipRule="evenodd"
			/>
		</svg>
	);
};

export const FacebookIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 17 }
		height={ 16 }
		fill="none"
	>
		<path
			fill="#6E6A69"
			fillRule="evenodd"
			d="M16.5 8a8 8 0 1 0-9.25 7.903v-5.59H5.218V8H7.25V6.237c0-2.005 1.195-3.113 3.022-3.113a12.3 12.3 0 0 1 1.79.157v1.968h-1.008c-.994 0-1.304.617-1.304 1.25V8h2.218l-.354 2.314H9.75v5.59A8 8 0 0 0 16.5 8Z"
			clipRule="evenodd"
		/>
		<path
			fill="#fff"
			fillRule="evenodd"
			d="M11.614 10.313 11.97 8H9.75V6.5c0-.633.31-1.25 1.304-1.25h1.01V3.28s-.917-.156-1.792-.156c-1.827 0-3.022 1.107-3.022 3.113V8H5.22v2.313H7.25v5.59a8.046 8.046 0 0 0 2.5 0v-5.59h1.864Z"
			clipRule="evenodd"
		/>
	</svg>
);
export const TwitterXIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 17 }
		height={ 16 }
		fill="none"
	>
		<circle cx={ 8.5 } cy={ 8 } r={ 8 } fill="#6E6A69" />
		<g clipPath="">
			<path
				fill="#fff"
				d="M9.262 7.462 12.24 4h-.706L8.95 7.006 6.883 4H4.501l3.123 4.545-3.123 3.63h.706l2.73-3.174 2.182 3.175H12.5l-3.24-4.714h.001Zm-.967 1.124-.316-.453L5.461 4.53h1.084l2.032 2.907.317.453 2.64 3.778h-1.083L8.295 8.586Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M4.498 4h8v8.18h-8z" />
			</clipPath>
		</defs>
	</svg>
);
export const WordPressIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 17 }
		height={ 16 }
		fill="none"
	>
		<path
			fill="#6E6A69"
			d="M16.5 8c0-4.408-3.592-8-8-8-4.416 0-8 3.592-8 8 0 4.416 3.584 8 8 8 4.408 0 8-3.584 8-8Zm-9.776 4.296-2.728-7.32c.44-.016.936-.064.936-.064.4-.048.352-.904-.048-.888 0 0-1.16.088-1.896.088-.144 0-.296 0-.464-.008A7.097 7.097 0 0 1 8.5.888c1.864 0 3.56.696 4.84 1.872-.544-.088-1.32.312-1.32 1.264 0 .592.36 1.088.72 1.68.28.488.44 1.088.44 1.968 0 1.192-1.12 4-1.12 4L9.636 4.976c.432-.016.656-.136.656-.136.4-.04.352-1-.048-.976 0 0-1.152.096-1.904.096-.696 0-1.864-.096-1.864-.096-.4-.024-.448.96-.048.976l.736.064 1.008 2.728-1.448 4.664ZM14.428 8c.192-.512.592-1.496.344-3.4.56 1.032.84 2.168.84 3.4 0 2.632-1.384 4.992-3.52 6.224.776-2.072 1.552-4.16 2.336-6.224ZM5.38 14.472C2.996 13.32 1.388 10.824 1.388 8c0-1.04.184-1.984.576-2.872C3.1 8.24 4.236 11.36 5.38 14.472Zm3.224-5.304 2.064 5.584a6.734 6.734 0 0 1-2.168.36 6.301 6.301 0 0 1-1.832-.264c.648-1.904 1.296-3.792 1.936-5.68Z"
		/>
	</svg>
);
export const YoutubeIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 23 }
		height={ 16 }
		fill="none"
	>
		<path
			fill="#6E6A69"
			d="M22.037 2.5C21.784 1.515 21.04.74 20.092.478 18.377 0 11.497 0 11.497 0s-6.88 0-8.595.478C1.955.74 1.21 1.516.957 2.499c-.46 1.783-.46 5.502-.46 5.502s0 3.719.46 5.502c.253.983.998 1.758 1.945 2.02 1.715.478 8.595.478 8.595.478s6.88 0 8.595-.478c.947-.262 1.692-1.037 1.945-2.02.46-1.783.46-5.502.46-5.502s0-3.72-.46-5.502Z"
		/>
		<path fill="#fff" d="M9.247 11.378 14.997 8l-5.75-3.376v6.753Z" />
	</svg>
);

export const LoveIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={ 16 }
			height={ 16 }
			fill="none"
		>
			<path
				fill="#E57373"
				d="M11.707 1.5C9.873 1.112 8.577 2.105 8 2.692c-.577-.585-1.865-1.58-3.707-1.192-1.166.243-2.19 1.167-2.763 2.49-.63 1.452-.575 3.032.147 4.228 1.365 2.264 5.866 5.99 6.058 6.149l.265.22.265-.219c.192-.158 4.693-3.885 6.058-6.148.722-1.197.777-2.777.147-4.228-.573-1.315-1.605-2.247-2.763-2.492Zm1.903 6.29C12.5 9.628 9 12.667 8 13.5c-1-.833-4.5-3.873-5.61-5.713-.583-.967-.618-2.262-.095-3.465.465-1.07 1.277-1.82 2.167-2a3.04 3.04 0 0 1 .641-.069c1.575 0 2.51 1.26 2.555 1.324l.334.473.333-.475c.013-.017 1.22-1.667 3.197-1.253.893.188 1.705.938 2.166 2 .54 1.206.505 2.501-.078 3.468Z"
			/>
			<path
				fill="#E57373"
				d="M13.61 7.79C12.5 9.628 9 12.667 8 13.5c-1-.833-4.5-3.873-5.61-5.713-.583-.967-.618-2.262-.095-3.465.465-1.07 1.277-1.82 2.167-2a3.04 3.04 0 0 1 .641-.069c1.575 0 2.51 1.26 2.555 1.324l.334.473.333-.475c.013-.017 1.22-1.667 3.197-1.253.893.188 1.705.938 2.166 2 .54 1.206.505 2.501-.078 3.468Z"
			/>
		</svg>
	);
};

export const RightArrow = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 20 }
		height={ 13 }
		viewBox="0 0 5 9"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.15403 0.865234L4.74524 4.81555L1.15403 8.76588L0.423828 8.10206L3.41156 4.81555L0.423829 1.52906L1.15403 0.865234Z"
			fill="#757575"
		/>
	</svg>
);

export const RotateIcon = () => (
	<svg
		width={12}
		height={13}
		viewBox="0 0 12 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#RotateIcon)">
		<path
			d="M1.251 0a.6.6 0 0 1 .6.6v1.142a5.95 5.95 0 0 1 9.157 1.432 5.95 5.95 0 0 1-1.302 7.505 5.953 5.953 0 0 1-9.695-3.4.6.6 0 0 1 1.179-.23 4.75 4.75 0 1 0 1.412-4.366l1.404-.135a.6.6 0 0 1 .114 1.194l-2.92.281a.5.5 0 0 1-.548-.498V.6a.6.6 0 0 1 .6-.6m3.875 4.048c.36 0 .65.291.65.65v2.25a.1.1 0 0 0 .1.1h1.25a.651.651 0 0 1 0 1.3h-1.65a1 1 0 0 1-1-1v-2.65a.65.65 0 0 1 .65-.65"
			fill="#fff"
		/>
		</g>
		<defs>
		<clipPath id="RotateIcon">
			<path fill="#fff" d="M0 0h11.803v12.095H0z" />
		</clipPath>
		</defs>
	</svg>
);

export const LeftArrow = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 20 }
		height={ 13 }
		viewBox="0 0 5 9"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.26589 0.865234L0.674678 4.81555L4.26589 8.76588L4.99609 8.10206L2.00836 4.81555L4.99609 1.52906L4.26589 0.865234Z"
			fill="#757575"
		/>
	</svg>
);

export const RightArrowLong = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 35 }
		height={ 12 }
		viewBox="0 0 35 12"
		fill="none"
	>
		<path
			d="M1.5 5.25a.75.75 0 0 0 0 1.5zm32.53 1.28a.75.75 0 0 0 0-1.06L29.257.697a.75.75 0 0 0-1.06 1.06L32.439 6l-4.242 4.243a.75.75 0 0 0 1.06 1.06zM1.5 6v.75h32v-1.5h-32z"
			fill="#838487"
		/>
	</svg>
);

export const TickIcon = () => (
	<svg
		width={ 16 }
		height={ 15 }
		viewBox="0 0 16 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 7.733 4.968 15h2.129L16 1.533 13.935 0l-8 9.467L2 5.733z"
			fill="#fff"
		/>
	</svg>
);

export const EditPencilIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M10.1421 3.98828L11.0765 3.05377C11.5927 2.53766 12.4295 2.53766 12.9456 3.05377C13.4617 3.56989 13.4617 4.40667 12.9456 4.92279L12.0111 5.85729M10.1421 3.98828L4.65284 9.47755C3.95597 10.1744 3.60752 10.5228 3.37026 10.9474C3.133 11.372 2.89428 12.3746 2.66602 13.3334C3.62474 13.1051 4.62734 12.8664 5.05194 12.6291C5.47654 12.3918 5.82498 12.0434 6.52185 11.3466L12.0111 5.85729M10.1421 3.98828L12.0111 5.85729"
			stroke="#757575"
			strokeWidth={ 1.25 }
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.33398 13.3333H11.334"
			stroke="#757575"
			strokeWidth={ 1.25 }
			strokeLinecap="round"
		/>
	</svg>
);

export const CopyIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
	>
		<g clipPath="url(#clip0_20469_150666)">
			<path
				d="M6 10C6 8.1144 6 7.1716 6.58579 6.58579C7.1716 6 8.1144 6 10 6H10.6667C12.5523 6 13.4951 6 14.0809 6.58579C14.6667 7.1716 14.6667 8.1144 14.6667 10V10.6667C14.6667 12.5523 14.6667 13.4951 14.0809 14.0809C13.4951 14.6667 12.5523 14.6667 10.6667 14.6667H10C8.1144 14.6667 7.1716 14.6667 6.58579 14.0809C6 13.4951 6 12.5523 6 10.6667V10Z"
				stroke="#757575"
				strokeWidth={ 1.25 }
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.3339 5.99998C11.3323 4.02859 11.3025 3.00745 10.7286 2.30827C10.6178 2.17324 10.494 2.04943 10.359 1.93862C9.62145 1.33331 8.52565 1.33331 6.33398 1.33331C4.14233 1.33331 3.0465 1.33331 2.30894 1.93862C2.17391 2.04943 2.0501 2.17324 1.93929 2.30827C1.33398 3.04583 1.33398 4.14166 1.33398 6.33331C1.33398 8.52498 1.33398 9.62078 1.93929 10.3584C2.0501 10.4934 2.17391 10.6172 2.30894 10.728C3.00812 11.3018 4.02926 11.3316 6.00065 11.3332"
				stroke="#757575"
				strokeWidth={ 1.25 }
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_20469_150666">
				<rect width={ 16 } height={ 16 } fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const DeleteBinIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M13 3.66669L12.5869 10.3501C12.4813 12.0576 12.4285 12.9114 12.0005 13.5253C11.7889 13.8288 11.5165 14.0849 11.2005 14.2774C10.5614 14.6667 9.706 14.6667 7.99513 14.6667C6.28208 14.6667 5.42553 14.6667 4.78603 14.2766C4.46987 14.0838 4.19733 13.8272 3.98579 13.5232C3.55792 12.9084 3.5063 12.0534 3.40307 10.3435L3 3.66669"
			stroke="#757575"
			strokeWidth={ 1.25 }
			strokeLinecap="round"
		/>
		<path
			d="M2 3.66665H14M10.7038 3.66665L10.2487 2.7278C9.9464 2.10415 9.7952 1.79233 9.53447 1.59785C9.47667 1.55471 9.4154 1.51634 9.35133 1.48311C9.0626 1.33331 8.71607 1.33331 8.023 1.33331C7.31253 1.33331 6.95733 1.33331 6.66379 1.48939C6.59873 1.52399 6.53665 1.56391 6.47819 1.60876C6.21443 1.81111 6.06709 2.13435 5.77241 2.78082L5.36861 3.66665"
			stroke="#757575"
			strokeWidth={ 1.25 }
			strokeLinecap="round"
		/>
		<path
			d="M6.33398 11V7"
			stroke="#757575"
			strokeWidth={ 1.25 }
			strokeLinecap="round"
		/>
		<path
			d="M9.66602 11V7"
			stroke="#757575"
			strokeWidth={ 1.25 }
			strokeLinecap="round"
		/>
	</svg>
);

// ArrowRight - alias for RightArrow
export const ArrowRight = () => (
	<svg
		width={12}
		height={12}
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
		d="m2 10 8-8m0 6.153V2H3.846"
		stroke="currentColor"
		strokeWidth={1.5}
		strokeLinecap="round"
		strokeLinejoin="round"
		/>
	</svg>
);

// ExternalLink icon
export const ExternalLink = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 14 }
		height={ 14 }
		viewBox="0 0 14 14"
		fill="none"
	>
		<path
			d="M9.33333 4.66667H10.5C10.8536 4.66667 11.1928 4.80714 11.4428 5.05719C11.6929 5.30724 11.8333 5.64638 11.8333 6V10.5C11.8333 10.8536 11.6929 11.1928 11.4428 11.4428C11.1928 11.6929 10.8536 11.8333 10.5 11.8333H3.5C3.14638 11.8333 2.80724 11.6929 2.55719 11.4428C2.30714 11.1928 2.16667 10.8536 2.16667 10.5V6C2.16667 5.64638 2.30714 5.30724 2.55719 5.05719C2.80724 4.80714 3.14638 4.66667 3.5 4.66667H4.66667"
			stroke="currentColor"
			strokeWidth={ 1.25 }
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.16667 2.16667H11.8333V5.83333"
			stroke="currentColor"
			strokeWidth={ 1.25 }
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.8333 2.16667L5.83333 8.16667"
			stroke="currentColor"
			strokeWidth={ 1.25 }
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

// PlayIcon
export const PlayIcon = ({color = "#fff"}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 24 }
		height={ 24 }
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			d="M5 3L19 12L5 21V3Z"
			fill={color}
			stroke={color}
			strokeWidth={ 2 }
			strokeLinejoin="round"
		/>
	</svg>
);

export const OurPluginsIcon = () => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_25995_249574)">
			<path
				d="M4.65129 4.92767L5.48877 3.93497L13.4466 12.1924L12.3618 12.9285C11.7111 13.5555 9.97594 13.9286 8.90513 13.9088L5.41372 13.8443L4.2773 14.9395C3.73658 15.4606 2.88173 15.4448 2.36962 14.9042C2.24569 14.7772 2.1482 14.6268 2.08282 14.4618C2.01744 14.2968 1.98546 14.1205 1.98874 13.943C1.99202 13.7656 2.03049 13.5905 2.10192 13.4281C2.17335 13.2656 2.27632 13.1189 2.40487 12.9966L3.54129 11.9014L3.60579 8.40995C3.62458 7.39313 4.01876 5.54609 4.65129 4.92767Z"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
			<path
				d="M12.0812 2.49165C12.4413 2.14903 12.4554 1.57936 12.1128 1.21925C11.7702 0.859139 11.2005 0.844959 10.8404 1.18758L11.4608 1.83961L12.0812 2.49165ZM8.23339 4.91026L8.85375 5.56229L12.0812 2.49165L11.4608 1.83961L10.8404 1.18758L7.61302 4.25822L8.23339 4.91026Z"
				fill="currentColor"
			/>
			<path
				d="M16.7339 7.38227C17.094 7.03965 17.1082 6.46998 16.7656 6.10987C16.423 5.74976 15.8533 5.73558 15.4932 6.0782L16.1136 6.73024L16.7339 7.38227ZM12.8862 9.80088L13.5065 10.4529L16.7339 7.38227L16.1136 6.73024L15.4932 6.0782L12.2658 9.14885L12.8862 9.80088Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_25995_249574">
				<rect width="18" height="18" fill="white"/>
			</clipPath>
		</defs>
	</svg>
);

export const StarIcon = ({color = "#F4674D"}) => (
  <svg
    width={16}
    height={15}
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.70547 0L9.84795 5.15113L15.409 5.59696L11.1721 9.22637L12.4665 14.653L7.70547 11.745L2.94441 14.653L4.23887 9.22637L0.00191116 5.59696L5.56299 5.15113L7.70547 0Z"
      fill={color}
    />
  </svg>
);

export const HalfStarIcon = () => (
  <svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m8.1 0 2.143 5.151 5.56.446-4.236 3.63 1.294 5.426L8.1 11.745l-4.761 2.908 1.294-5.427L.396 5.597l5.562-.446z"
      fill="#f4674d"
    />
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={15}
    >
      <path
        d="m8.1 0 2.143 5.151 5.56.446-4.236 3.63 1.294 5.426L8.1 11.745l-4.761 2.908 1.294-5.427L.396 5.597l5.562-.446z"
        fill="#ffc329"
      />
    </mask>
    <g mask="url(#a)">
      <path fill="#d9d9d9" d="M10.668.1h5v15h-5z" />
    </g>
  </svg>
);


